import { useState, useCallback } from "react";

const DEFAULT_CONFIG = {
  product_usage: {
    login: "medium",
  },
  communication: {
    sentiment: "medium",
    expansion_inquiry: "medium",
    champion_leaving: "medium",
    support_ticket_frequency: "medium",
    support_ticket_avg_time_to_close: "medium",
  },
  contract_metrics: {
    mrr: "medium",
    champion_left: "medium",
    csm_feedback: "medium",
  },
  csat_nps: {
    nps_score: "medium",
    csat_score: "medium",
  },
};

// API calls disabled - using local state only until backend is updated
export const useSensitivity = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error] = useState(null);

  const fetchConfig = useCallback(() => {
    // No-op: API disabled
  }, []);

  const updateConfig = useCallback(async (newConfig) => {
    setSaving(true);
    setConfig(newConfig);
    setSaving(false);
    return newConfig;
  }, []);

  return {
    config,
    setConfig,
    loading,
    saving,
    error,
    updateConfig,
    refetch: fetchConfig,
  };
};
